<script setup lang="ts">
import FormCheck from "../FormCheck";
</script>

<template>
  <FormCheck.Label>
    <slot></slot>
  </FormCheck.Label>
</template>
